<template>
    <o-form :title="$t('sandoz.sales_line')" class="ortic-form-horizontal" ref="form"
            :url="'/api/sandoz/sales_lines/' + $route.params.id +'?include=price_categories,access,access.user'">
        <template slot-scope="props">
            <b-row>
                <b-col>
                    <o-input :errorField="'sales_line'" :label="$t('sandoz.sales_line')"
                             v-model="props.item.sales_line"/>

                    <div class="form-group">
                        <label> {{ $t('sandoz.maximum_invest') }}</label>
                        <div class="w-100">
                            <div class="input-group">
                                <o-input-percentage-control :errorField="'maximum_invest'" v-model="props.item.maximum_invest" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                                <div role="group" class="input-group-append">
                                  <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label> {{ $t('sandoz.maximum_invest_expectation') }}</label>
                        <div class="w-100">
                            <div class="input-group">
                                <o-input-percentage-control :errorField="'maximum_invest_expectation'" v-model="props.item.maximum_invest_expectation" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                                <div role="group" class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label> {{ $t('sandoz.deviation_range_1') }}</label>
                        <div class="w-100">
                            <div class="input-group">
                                <o-input-percentage-control :errorField="'deviation_range_1'" v-model="props.item.deviation_range_1" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                                <div role="group" class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label> {{ $t('sandoz.deviation_range_2') }}</label>
                        <div class="w-100">
                            <div class="input-group">
                                <o-input-percentage-control :errorField="'deviation_range_2'" v-model="props.item.deviation_range_2" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                                <div role="group" class="input-group-append">
                                  <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label> {{ $t('sandoz.deviation_range_3') }}</label>
                        <div class="w-100">
                            <div class="input-group">
                                <o-input-percentage-control :errorField="'deviation_range_3'" v-model="props.item.deviation_range_3" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                                <div role="group" class="input-group-append">
                                  <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label> {{ $t('sandoz.deviation_min_growth') }}</label>
                        <div class="w-100">
                            <div class="input-group">
                                <o-input-percentage-control :errorField="'deviation_min_growth'" v-model="props.item.deviation_min_growth" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                                <div role="group" class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <o-input :errorField="'budget_tolerance'" :label="$t('sandoz.budget_tolerance')" v-model="props.item.budget_tolerance" type="number" format="number"/>

                    <o-value-select :errorField="'suggested_start_month'" :items="months" :label="$t('sandoz.suggested_start_month')"
                                    v-model="props.item.suggested_start_month"/>
                   <!-- <hr>

                    <div class="form-group">
                      <label> {{ $t('sandoz.plan_turnover_range_percentage_min') }}</label>
                      <div class="w-100">
                        <div class="input-group">
                          <o-input-percentage-control :errorField="'plan_turnover_range_percentage_min'" v-model="props.item.plan_turnover_range_percentage_min" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                          <div role="group" class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label> {{ $t('sandoz.plan_turnover_range_percentage_max') }}</label>
                      <div class="w-100">
                        <div class="input-group">
                          <o-input-percentage-control :errorField="'plan_turnover_range_percentage_max'" v-model="props.item.plan_turnover_range_percentage_max" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                          <div role="group" class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <o-input :label="$t('sandoz.plan_turnover_range_min')" v-model="props.item.plan_turnover_range_min" format="number"/>
                    <o-input :label="$t('sandoz.plan_turnover_range_max')" v-model="props.item.plan_turnover_range_max" format="number"/>

                    <hr>

                    <div class="form-group">
                      <label> {{ $t('sandoz.plan_turnover_expectation_range_percentage_min') }}</label>
                      <div class="w-100">
                        <div class="input-group">
                          <o-input-percentage-control :errorField="'plan_turnover_expectation_range_percentage_min'" v-model="props.item.plan_turnover_expectation_range_percentage_min" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                          <div role="group" class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group">
                      <label> {{ $t('sandoz.plan_turnover_expectation_range_percentage_max') }}</label>
                      <div class="w-100">
                        <div class="input-group">
                          <o-input-percentage-control :errorField="'plan_turnover_expectation_range_percentage_max'" v-model="props.item.plan_turnover_expectation_range_percentage_max" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                          <div role="group" class="input-group-append">
                            <span class="input-group-text">%</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <o-input :label="$t('sandoz.plan_turnover_expectation_range_min')" v-model="props.item.plan_turnover_expectation_range_min" format="number"/>
                    <o-input :label="$t('sandoz.plan_turnover_expectation_range_max')" v-model="props.item.plan_turnover_expectation_range_max" format="number"/> -->

                </b-col>
                <b-col>

                  <!-- <div class="form-group">
                    <label> {{ $t('sandoz.plan_invest_range_percentage_min') }}</label>
                    <div class="w-100">
                      <div class="input-group">
                        <o-input-percentage-control :errorField="'plan_invest_range_percentage_min'" v-model="props.item.plan_invest_range_percentage_min" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                        <div role="group" class="input-group-append">
                          <span class="input-group-text">%</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label> {{ $t('sandoz.plan_invest_range_percentage_max') }}</label>
                    <div class="w-100">
                      <div class="input-group">
                        <o-input-percentage-control :errorField="'plan_invest_range_percentage_max'" v-model="props.item.plan_invest_range_percentage_max" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                        <div role="group" class="input-group-append">
                          <span class="input-group-text">%</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <o-input :label="$t('sandoz.plan_invest_range_min')" v-model="props.item.plan_invest_range_min" format="number"/>
                  <o-input :label="$t('sandoz.plan_invest_range_max')" v-model="props.item.plan_invest_range_max" format="number"/>

                  <hr>

                  <div class="form-group">
                    <label> {{ $t('sandoz.plan_discount_range_percentage_min') }}</label>
                    <div class="w-100">
                      <div class="input-group">
                        <o-input-percentage-control :errorField="'plan_discount_range_percentage_min'" v-model="props.item.plan_discount_range_percentage_min" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                        <div role="group" class="input-group-append">
                          <span class="input-group-text">%</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label> {{ $t('sandoz.plan_discount_range_percentage_max') }}</label>
                    <div class="w-100">
                      <div class="input-group">
                        <o-input-percentage-control :errorField="'plan_discount_range_percentage_max'" v-model="props.item.plan_discount_range_percentage_max" type="number" :min="0.01" :max="99.99" :only-integer="false" :lazy="true" append="%"/>
                        <div role="group" class="input-group-append">
                          <span class="input-group-text">%</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <o-input :label="$t('sandoz.plan_discount_range_min')" v-model="props.item.plan_discount_range_min" format="number"/>
                  <o-input :label="$t('sandoz.plan_discount_range_max')" v-model="props.item.plan_discount_range_max" format="number"/>

                  <hr> -->

                    <o-checkbox :errorField="'automatic_approval_allowed'" :label="$t('sandoz.automatic_approval_allowed')"
                                v-model="props.item.automatic_approval_allowed"/>

                    <o-input :errorField="'email_recipient_when_committed'" :label="$t('sandoz.email_recipient_when_committed')"
                             v-model="props.item.email_recipient_when_committed"/>
                    <o-input :errorField="'email_recipient_when_approved'" :label="$t('sandoz.email_recipient_when_approved')"
                             v-model="props.item.email_recipient_when_approved"/>
                    <o-input :errorField="'email_recipient_when_automatically_approved'" :label="$t('sandoz.email_recipient_when_automatically_approved')"
                             v-model="props.item.email_recipient_when_automatically_approved"/>
                    <o-input :errorField="'adhoc_order_recipient'" :label="$t('sandoz.adhoc_order_recipient')"
                             v-model="props.item.adhoc_order_recipient"/>

                    <o-input :errorField="'vendor_form_recipients'" :label="$t('sandoz.vendor_form_recipients')"
                             v-model="props.item.vendor_form_recipients"/>

                    <o-checkbox :errorField="'attach_pdf_approval_notification'" :label="$t('sandoz.attach_pdf_approval_notification')"
                                v-model="props.item.attach_pdf_approval_notification"/>

                    <o-checkbox :errorField="'send_approval_notification'" :label="$t('sandoz.send_approval_notification')"
                                v-model="props.item.send_approval_notification"/>

                    <o-checkbox :errorField="'invoicing_disabled'" :label="$t('sandoz.invoicing_disabled')"
                                v-model="props.item.invoicing_disabled"/>

                    <o-checkbox :errorField="'show_invoice_details'" :label="$t('sandoz.show_invoice_details')"
                                v-model="props.item.show_invoice_details"/>

                     <o-checkbox :errorField="'bank_information_mandatory'" :label="$t('sandoz.bank_information_mandatory')"
                                v-model="props.item.bank_information_mandatory"/>

                     <o-checkbox :errorField="'disable_contract_row_level_security'" :label="$t('sandoz.disable_contract_row_level_security')"
                                v-model="props.item.disable_contract_row_level_security"/>

                    <o-input :errorField="'invoice_verification_recipients'" :label="$t('sandoz.invoice_verification_recipients')"
                             v-model="props.item.invoice_verification_recipients"/>
                </b-col>
            </b-row>
        </template>
        <template slot="child" slot-scope="props">
            <b-tabs>
                <b-tab :title="$t('sandoz.price_categories')" active>
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.price_category')}}</th>
                                    <th>{{$t('sandoz.category_type')}}</th>
                                    <th>{{$t('sandoz.cap_method')}}</th>
                                    <th>{{$t('sandoz.cap')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="setCategory()"
                                               variant="primary">
                                            <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(category, i) in props.item.price_categories">
                                    <td>{{category.price_category}}</td>
                                    <td>{{category.category_type ? $i18n.t('sandoz.' + category.category_type): ''}}</td>
                                    <td>{{category.cap_method ? $i18n.t('sandoz.' + category.cap_method): ''}}</td>
                                    <td>{{category.cap}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.price_categories.splice(i, 1)"
                                                   variant="secondary">
                                                <fa icon="times"/>
                                            </b-btn>
                                            <b-btn @click.prevent="setCategory(i)" variant="primary">
                                                <fa icon="pencil-alt"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
                <b-tab :title="$t('sandoz.access')">
                    <o-card>
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>{{$t('sandoz.user')}}</th>
                                    <th class="text-right">
                                        <b-btn @click.prevent="showUserModel()" variant="primary">
                                          <fa icon="plus"/>
                                        </b-btn>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(access, i) in props.item.access" :key="access.id">
                                    <td :title="access.id">{{access.user.name}}</td>
                                    <td class="text-right text-nowrap">
                                        <div aria-label="edit controls" class="btn-group btn-group-sm" role="group">
                                            <b-btn @click.prevent="props.item.access.splice(i, 1)" variant="secondary">
                                              <fa icon="times"/>
                                            </b-btn>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </o-card>
                </b-tab>
            </b-tabs>
            <b-modal id="modal-add-category" ref="addCategory" :title="$t('sandoz.add_price_category')"
                     @ok="addCategory()">
                <o-input :label="$t('sandoz.price_category')" v-model="price_category"></o-input>
                <o-value-select :items="categoryTypes" :label="$t('sandoz.category_type')"
                              v-model="categoryType"/>
                <o-value-select :items="capMethods" :label="$t('sandoz.cap_method')"
                              v-model="capMethod"/>
                <o-input :label="$t('sandoz.cap')" v-model="cap" format="number" />
            </b-modal>
            <b-modal :title="$t('sandoz.users')" @ok="closeUserModel" id="modal-access" ref="accessModal" size="lg">
                <o-table url="/api/system/users?filter%5Bactive%5D=1%25" ref="userList" :custom-row-button="true"
                         :enable-new="false" :shadow="false">
                    <template slot="filter">
                        <o-filter v-on:filter-updated="(filters) => $refs.userList.setFilters(filters)">
                          <o-filter-text :title="$t('core.name')" column="name"></o-filter-text>
                          <o-filter-text :title="$t('core.email')" column="email"></o-filter-text>
                        </o-filter>
                    </template>
                    <template slot="head">
                        <o-table-header column="name">{{$t('core.name')}}</o-table-header>
                        <o-table-header column="email">{{$t('core.email')}}</o-table-header>
                    </template>
                    <template slot="body" slot-scope="props">
                        <td>{{ props.item.name }}</td>
                        <td>{{ props.item.email }}</td>
                    </template>
                    <template slot="body-controls" slot-scope="props">
                        <td class="text-right">
                            <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                                <b-btn variant="secondary" @click="selectAccessUser(props.item)">
                                    <fa icon="sign-in-alt"/>
                                </b-btn>
                            </div>
                        </td>
                    </template>
                </o-table>
            </b-modal>
        </template>
    </o-form>
</template>

<script>

  export default {
    data: () => ({
      price_category: null,
      i: null,
      categoryType: null,
      capMethod: null,
      cap: null,
      categoryTypes: [],
      capMethods: [],
      months: []
    }),
    created() {
      this.categoryTypes = [
        {value: 'fte', text: this.$i18n.t('sandoz.fte')},
        {value: 'classification', text: this.$i18n.t('sandoz.classification')},
        {value: 'apo_one_sum_of_month', text: this.$i18n.t('sandoz.apo_one_sum_of_month')},
        {value: 'gadget_hcps', text: this.$i18n.t('sandoz.gadget_hcps')},
        {value: 'fixed', text: this.$i18n.t('sandoz.fixed')}
      ]

      this.capMethods = [
        {value: 'fixed', text: this.$i18n.t('sandoz.fixed')},
        {value: 'fte', text: this.$i18n.t('sandoz.fte')}
      ]

      this.months = [
        {value: 1, text: this.$i18n.t('core.january_long')},
        {value: 2, text: this.$i18n.t('core.february_long')},
        {value: 3, text: this.$i18n.t('core.march_long')},
        {value: 4, text: this.$i18n.t('core.april_long')},
        {value: 5, text: this.$i18n.t('core.may_long')},
        {value: 6, text: this.$i18n.t('core.june_long')},
        {value: 7, text: this.$i18n.t('core.july_long')},
        {value: 8, text: this.$i18n.t('core.august_long')},
        {value: 9, text: this.$i18n.t('core.september_long')},
        {value: 10, text: this.$i18n.t('core.october_long')},
        {value: 11, text: this.$i18n.t('core.november_long')},
        {value: 12, text: this.$i18n.t('core.december_long')}
      ]
    },
    methods: {
      setCategory(i = null) {
        this.i = i
        this.reset()
        if(this.i !== null) {
          this.price_category = this.$refs.form.item.price_categories[this.i].price_category
          this.categoryType = this.$refs.form.item.price_categories[this.i].category_type
          this.capMethod = this.$refs.form.item.price_categories[this.i].cap_method
          this.cap = this.$refs.form.item.price_categories[this.i].cap
        }
        this.$refs.addCategory.show()
      },
      addCategory() {
        if(this.i !== null) {
          this.$refs.form.item.price_categories[this.i].price_category  = this.price_category
          this.$refs.form.item.price_categories[this.i].category_type  = this.categoryType
          this.$refs.form.item.price_categories[this.i].cap_method  = this.capMethod
          this.$refs.form.item.price_categories[this.i].cap  = this.cap
        } else {
          if(this.price_category && this.price_category.trim()) {
            if(this.$refs.form.item.price_categories === undefined) {
              this.$refs.form.item.price_categories = [{
                price_category: this.price_category,
                category_type: this.categoryType,
                cap_method: this.capMethod,
                cap: this.cap,
                created_at: new Date()
              }]
            } else {
              this.$refs.form.item.price_categories.unshift({
                price_category: this.price_category,
                category_type: this.categoryType,
                cap_method: this.capMethod,
                cap: this.cap,
                created_at: new Date()
              })
            }
          }
        }

        this.reset()
        this.$refs.addCategory.hide()
      },
      reset() {
        this.price_category = null
        this.categoryType = null
        this.capMethod = null
        this.cap = null
      },
      showUserModel () {
        this.$refs.accessModal.show()
      },
      closeUserModel () {
        this.$refs.accessModal.hide()
      },
      selectAccessUser(access) {
        if(this.$refs.form.item.id === 'new') {
          this.$refs.form.item.access.push({
            'user_id': access.id,
            'user': access
          })
        } else {
          this.$refs.form.item.access.push({
            'sales_line_id': this.$refs.form.item.id,
            'user_id': access.id,
            'user': access
          })
        }
        this.closeUserModel()
      }
    }
  }
</script>
